import BaseService from './BaseService';

export default class InvoiceService extends BaseService {
	// Initializing important variables
	constructor() {
		super();
		this.path = 'image';
	}

	getImagePath(type){
		return new URL(`${this.domain}/${this.path}/${type}`);
	}
}
